import { useState, useRef, useEffect, useCallback } from 'react';
import Dropdown from '../../../Components/CustomDropdown/customdropdown';
import { useToast } from '../../../Utils/toastContext';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmContinueButton from '../../../Components/ContinueButton/continue-button';
import { updateFormData } from '../../../Redux/store/onboardingFormSlice';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import AddUserPopup from '../../../Components/add-joint-accounts/Add-User-Popup';
import MindmapTree from '../../../Components/Onbaording/onboarding-tree';
import countriesData from '../../../Data/CountryCodes.json';
import Select, { components } from 'react-select';
import { debounce } from 'lodash';
import { clearFileIdsRedux } from '../../../Redux/store/userSlice';
import { Plus, Minus } from 'lucide-react';
import {
  setApplicationTypeShareHolder,
  clearApplicationTypeShareHolder,
} from '../../../Redux/store/accountTypeSlice';
import ConfirmResetButton from '../../../Components/ContinueButton/reset-button';
import LabelWithStatus from '../../../Components/onboarding/label-with-status';
import ReviewPopup from '../../../Components/onboarding/review-popup';
import DocumentPreview from '../../Create-Investment/documentpreview';
import {
  setStepStatusShareholder,
  setRejectedFieldsShareholder,
  clearStepStatusShareholder,
  clearCurrentStepShareholder,
} from '../../../Redux/store/onboardingFormSlice';
const validator = require('validator');
const ShareholderLayer = ({
  layerName,
  shareholdersForLayer = [],
  rootEntities = [], // ✅ DEFINE PROP
  collapsed = false,
  shareholderTypesData = [],
  onToggle,
  getLayeredData,
}) => {
  const isOpen = !collapsed; // fully controlled
  const dispatch = useDispatch();
  const isRoot = shareholdersForLayer.length === 0;
  const { shareholderId, shareholderType, userType } = useParams();

  const navigate = useNavigate();
  const username = useSelector((state) => state.user.username);
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  // First layer shareholders
  const [shareholders, setShareholders] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const { showToast } = useToast();
  const [activeTab, setActiveTab] = useState(0);
  // Controls state
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');

  // Sub-layer shareholders (per tab)
  const [layerData, setLayerData] = useState(() => {
    let initial = {};
    shareholdersForLayer.forEach((s, idx) => {
      initial[idx] = [
        {
          id: Date.now(),
          name: '',
          type: 1,
          shares: '',
          userId: null,
          email: '',
          errors: {},
        },
      ];
    });
    return { [layerName]: initial };
  });
  const addShareholderapi = async (tabIdx) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      userType == 'trustee'
        ? `${BASE_URL}/api/v1/onboarding/trust/corporate-trustees/directors-n-shareholders/shareholders/submit/${shareholderId}`
        : `${BASE_URL}/api/v1/onboarding/stakeholder/corporate/directors-shareholders/shareholders/submit/${shareholderId}`;
    let payload = {
      shareholders:
        layerData[layerName]?.[tabIdx]?.length > 0
          ? layerData[layerName][tabIdx].map((item) => ({
              name: item.name,
              email: item.email,
              shareholder_type: item.type,
              percentage_ownership: item.shares,
            }))
          : shareholders.map((item) => ({
              name: item.name,
              email: item.email,
              shareholder_type: item.type,
              percentage_ownership: item.shares,
            })),
    };
    const bodyData = payload;
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleAddShareholders = useCallback(
    debounce(async (e, tabIdx = null) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addShareholderapi(tabIdx);
        if (response.status == 200) {
          showToast(response.message, 'success');
          handleFillApplication(tabIdx);
          getLayeredData();
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [shareholders], // Dependencies
  );

  const calculateSharesCounter = (list) => {
    const total = list.reduce((acc, s) => acc + Number(s.shares || 0), 0);
    return `${total.toFixed(2)}`;
  };
  // Helper function to determine if ECDD is pending
  const hasECDDPending = (shareholder) => {
    return shareholder?.hasPending || shareholder?.has_pending_edd || false;
  };
  /** ----------------------
   * Root Layer Handlers
   * ---------------------- */
  const updateRootShareholder = (id, field, value, errors = {}) => {
    setShareholders((prev) =>
      prev.map((s) => (s.id === id ? { ...s, [field]: value, errors } : s)),
    );
  };

  const addRootShareholder = () => {
    setShareholders((prev) => [
      ...prev,
      { id: Date.now(), name: '', type: 1, userId: null, shares: 0, email: '' },
    ]);
  };

  const removeRootShareholder = (id) => {
    setShareholders((prev) => prev.filter((s) => s.id !== id));
  };
  useEffect(() => {
    setActiveTab(0);

    if (!isRoot) {
      const initial = {};

      shareholdersForLayer.forEach((tab, idx) => {
        initial[idx] = tab.data.map((s) => ({
          id: s.shareholder_user_id,
          name: s.name,
          type: s.shareholder_type.id,
          userId: s.shareholder_user_id,
          shares: Number(s.percentage_ownership),
          hasPending: s.has_pending_edd,
          email: s.email,
          errors: {},
        }));
      });

      setLayerData({ [layerName]: initial });
    }
  }, [shareholdersForLayer]);

  useEffect(() => {
    if (shareholders.length > 0) {
      dispatch(updateFormData({ field: 'shareholders', value: shareholders }));
    }
  }, [shareholders]);
  useEffect(() => {
    if (isRoot && rootEntities?.length) {
      setShareholders(
        rootEntities.map((s) => ({
          id: s.shareholder_user_id,
          name: s.name || '',
          type: s.shareholder_type?.id ?? 1,
          userId: s.shareholder_user_id,
          shares: Number(s.percentage_ownership || 0),
          hasPending: s.has_pending_edd,
          email: s.email || '',
          errors: {},
        })),
      );
    }
  }, [isRoot, rootEntities]);
  useEffect(() => {
    if (layerData != null) {
      dispatch(updateFormData({ field: 'layerData', value: layerData }));
    }
  }, [layerData]);

  useEffect(() => {
    dispatch(clearApplicationTypeShareHolder());
  }, []);
  /** ----------------------
   * Sub-layer Handlers
   * ---------------------- */
  const updateShareholder = (tabIdx, idx, field, value, errors = {}) => {
    setLayerData((prev) => {
      const copy = { ...prev };

      // Ensure layerName exists
      if (!copy[layerName]) copy[layerName] = {};

      // Ensure tabIdx exists
      if (!Array.isArray(copy[layerName][tabIdx])) {
        copy[layerName][tabIdx] = [];
      }

      // Clone current tab data
      const tabData = [...copy[layerName][tabIdx]];
      const current = tabData[idx] || {};

      // Ensure value is safe for string fields
      tabData[idx] = {
        ...current,
        [field]: typeof value === 'string' ? value : '',
        errors,
      };

      // Assign back
      copy[layerName] = { ...copy[layerName], [tabIdx]: tabData };

      return copy;
    });
  };
  const addShareholder = (tabIdx) => {
    setLayerData((prev) => {
      const copy = { ...prev };
      copy[layerName][tabIdx] = [
        ...(copy[layerName][tabIdx] || []),
        {
          id: Date.now(),
          name: '',
          type: 1,
          shares: 0,
          userId: null,
          email: '',
          errors: {},
        },
      ];
      return copy;
    });
  };

  const removeShareholder = (tabIdx, id) => {
    setLayerData((prev) => {
      const copy = { ...prev };
      copy[layerName][tabIdx] = copy[layerName][tabIdx].filter(
        (s) => s.id !== id,
      );
      return copy;
    });
  };

  /** ----------------------
   * Fill Application
   * ---------------------- */
  // inside ShareholderLayer
  const handleFillApplication = (tabIdx = null) => {
    let qualified = [];

    if (shareholdersForLayer.length === 0) {
      // Root layer → pick only Corporate/Trust with shares >= 25
      qualified = shareholders.filter(
        (s) =>
          (Number(s.type) === 2 || Number(s.type) === 3) &&
          Number(s.shares) >= 25,
      );
    } else {
      // Sub-layers → collect from all tabs
      Object.values(layerData[layerName]).forEach((tabShareholders = []) => {
        const tabQualified = tabShareholders.filter(
          (s) =>
            (Number(s.type) === 2 || Number(s.type) === 3) &&
            Number(s.shares) >= 25,
        );
        qualified = [...qualified, ...tabQualified];
      });
    }

    if (qualified.length > 0) {
      // 1) Clear layerData forward from this layer
      // 2) Trim layers forward and add fresh next layer
      // onAddLayer(qualified, layerName, layerName);
    }
  };

  useEffect(() => {
    if (!shareholders.length) {
      setIsFormValid(false);
      return;
    }

    const allFilled = shareholders.every(
      (s) =>
        s.name.trim() !== '' &&
        s.email.trim() !== '' &&
        !s.errors?.email &&
        parseFloat(s.shares) > 0,
    );

    const totalShares = calculateSharesCounter(shareholders);
    if (allFilled && Number(totalShares) === 100.0) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [shareholders]);
  const isLayerFormValid = (tabIdx) => {
    const list = layerData[layerName][tabIdx] || [];
    if (!list.length) return false;

    // All rows filled (and no field errors)
    const allFilled = list.every(
      (s) =>
        s.name.trim() !== '' &&
        s.email.trim() !== '' &&
        !s.errors?.email &&
        parseFloat(s.shares) > 0,
    );

    // Shares must equal 100
    const totalShares = calculateSharesCounter(list);

    return allFilled && Number(totalShares).toFixed(2) === '100.00';
  };

  /** ----------------------
   * Render Controls Section
   * ---------------------- */
  const Controls = ({ list, isFirst, tabIdx }) => {
    const numShareholders = list.length;
    const shareCounter = calculateSharesCounter(list);

    return (
      <div className="font-medium flex flex-wrap items-center justify-between px-4 py-3 text-sm">
        {/* Show Records */}
        <div className="flex items-center gap-2">
          <label className="text-[#8C8C8C]">Show Records</label>
          <select
            value={recordsPerPage}
            onChange={(e) => setRecordsPerPage(Number(e.target.value))}
            className="border rounded-lg px-2 py-1 text-black focus:outline-none focus:ring-1 focus:ring-gray-300"
          >
            <option>10</option>
            <option>20</option>
            <option>50</option>
          </select>
        </div>

        {/* Search */}
        <div className="relative">
          <input
            type="text"
            className="p-2 pl-8 border rounded-xl"
            placeholder="Search Shareholder"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <span className="absolute left-2 top-3 text-gray-500">
            {' '}
            <img src="/search-normal.svg" alt="Company Logo" className="mr-2" />
          </span>
        </div>
        {/* Shareholders Count */}
        {isFirst && (
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#464646]">
              NO OF SHAREHOLDERS
            </span>
            <div className="font-semibold">
              <div className="flex items-center text-sm mt-1 md:mt-0 space-x-0 ml-1 border  rounded-md bg-white shadow-md">
                {/* Remove last row */}
                <button
                  onClick={() => {
                    setShareholders((prev) => {
                      if (prev.length === 0) return prev; // avoid error if no rows
                      const lastId = prev[prev.length - 1].id;
                      return prev.filter((s) => s.id !== lastId);
                    });
                  }}
                  className="text-black px-2"
                >
                  <Minus size={18} />
                </button>

                {/* Count display */}
                <span className="text-sm font-medium bg-[#375AE7] text-white p-2">
                  {shareholders.length.toString().padStart(2, '0')}
                </span>

                {/* Add new row */}
                <button
                  onClick={addRootShareholder}
                  className="text-black px-2"
                >
                  <Plus size={18} />
                </button>
              </div>
            </div>
          </div>
        )}
        {!isFirst && (
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#464646]">
              NO OF SHAREHOLDERS
            </span>

            <div className="font-semibold">
              <div className="flex items-center text-sm mt-1 md:mt-0 space-x-0 ml-1 border rounded-md bg-white shadow-md">
                {/* Count display */}
                <span className="text-sm font-medium bg-[#375AE7] text-white px-3 py-1">
                  {(layerData[layerName]?.[tabIdx]?.length || 0)
                    .toString()
                    .padStart(2, '0')}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Shares Counter */}
        <div className="flex items-center gap-2 font-medium">
          <span className=" text-[#464646]">SHARES COUNTER</span>
          <div
            className={`${
              shareCounter != 100.0 ? 'text-red-600' : 'text-green-600'
            }
          border rounded-lg px-3 py-1  font-semibold`}
          >
            {shareCounter}%
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="border rounded-2xl shadow-sm bg-white mb-6">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      <div
        onClick={onToggle}
        className="bg-[#375AE7] text-white px-4 py-2 rounded-t-2xl flex justify-between items-center cursor-pointer"
      >
        <h2 className="text-sm font-medium">{layerName}</h2>
        <span className="text-lg">{isOpen ? '−' : '+'}</span>
      </div>

      {isOpen && (
        <>
          {/* CASE 1: Root Layer (no tabs) */}
          {shareholdersForLayer.length === 0 && (
            <div className="p-4 border rounded-b-lg">
              {/* Controls */}
              <Controls list={shareholders} isFirst={true} />
              {calculateSharesCounter(shareholders) != 100.0 && (
                <div className=" flex mx-5 my-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                  <div className="flex  items-center">
                    <img
                      src="/danger.svg"
                      alt="Arrow"
                      className=" left-0 w-5 h-5 mr-2"
                    />{' '}
                    Missing shareholder information or incorrect percentages
                    entered. Please ensure all shareholder's share percentages
                    are entered accurately until the "Shares Counter" reaches
                    100%.
                  </div>
                </div>
              )}
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-[#8C8C8C]">
                  <thead className="">
                    <tr className="border-[#EDEDED] border font-medium">
                      <th className="p-2 text-left font-medium"></th>
                      <th className="p-2 text-left font-medium">
                        Shareholder Name
                      </th>
                      <th className="p-2 text-left font-medium">
                        Type Of Shareholder
                      </th>
                      <th className="p-2 text-left font-medium">Shares</th>
                      <th className="p-2 text-left font-medium">
                        Email Address
                      </th>
                      <th className="p-2 text-left font-medium">
                        User Registration
                      </th>
                      <th className="p-2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {shareholders.map((s, i) => (
                      <tr key={s.id} className="border-t font-medium">
                        <td className="p-2 text-[#8C8C8C]">
                          {String(i + 1).padStart(2, '0')}.
                        </td>
                        <td className="p-2 text-black">
                          <input
                            className="border w-full p-2 rounded-xl text-sm"
                            value={s.name}
                            onChange={(e) =>
                              updateRootShareholder(
                                s.id,
                                'name',
                                e.target.value,
                              )
                            }
                          />
                        </td>
                        <td className="p-2 text-black">
                          <select
                            className="w-full border p-2 rounded-xl text-sm"
                            value={s.type}
                            onChange={(e) =>
                              updateRootShareholder(
                                s.id,
                                'type',
                                e.target.value,
                              )
                            }
                          >
                            {shareholderTypesData.map((c) => (
                              <option key={c.value} value={c.value}>
                                {c.label}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td className="p-2 text-black">
                          <div className="relative w-24">
                            <input
                              type="number"
                              value={s.shares}
                              min="0"
                              onChange={(e) =>
                                updateRootShareholder(
                                  s.id,
                                  'shares',
                                  e.target.value,
                                )
                              }
                              onBlur={(e) => {
                                let value = parseFloat(e.target.value) || 0;
                                updateRootShareholder(
                                  s.id,
                                  'shares',
                                  value.toFixed(2),
                                );
                              }}
                              placeholder="10.00"
                              className={`p-2 pr-8 text-black w-full font-medium border rounded-xl text-md transition-all duration-200 ${'border-gray-300'}`}
                            />
                            <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 text-sm">%</span>
                            </div>
                          </div>
                        </td>
                        <td className="p-2 text-black">
                          <input
                            type="email"
                            className={` ${
                              s.errors?.email ? 'border-[#FF5050]' : ''
                            }
                            border w-full p-2 rounded-xl text-sm`}
                            value={s.email}
                            onChange={(e) => {
                              const value = e.target.value;
                              const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                value,
                              );
                              updateRootShareholder(
                                s.id,
                                'email',
                                e.target.value,
                                {
                                  ...s.errors,
                                  email:
                                    isValid || value === ''
                                      ? ''
                                      : 'Invalid email',
                                },
                              );
                            }}
                          />
                          {s.errors?.email && (
                            <span className="text-red-500 text-xs">
                              {s.errors.email}
                            </span>
                          )}
                        </td>
                        <td className="p-2">
                          {s.userId != null ? (
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                dispatch(clearStepStatusShareholder());
                                dispatch(clearCurrentStepShareholder());

                                if (s.hasPending) {
                                  let redirectState = {
                                    path: `/edd-stakeholder/${s.id}/${s.type}/shareholder/${false}/${s.name}`,
                                    state: {
                                      from: location.pathname,
                                    },
                                  };
                                  sessionStorage.setItem(
                                    'redirectAfterLogin',
                                    JSON.stringify(redirectState),
                                  );
                                  navigate(
                                    `/edd-stakeholder/${s.id}/${s.type}/shareholder/${false}/${s.name}`,
                                    {
                                      state: {
                                        from: location.pathname,
                                      },
                                    },
                                  );
                                } else {
                                  let redirectState = {
                                    path: `/onboarding-shareholder/${s.id}/${s.type}/shareholder/${false}/${s.name}`,
                                    state: {
                                      from: location.pathname,
                                    },
                                  };
                                  sessionStorage.setItem(
                                    'redirectAfterLogin',
                                    JSON.stringify(redirectState),
                                  );
                                  navigate(
                                    `/onboarding-shareholder/${s.id}/${s.type}/shareholder/${false}/${s.name}`,
                                    {
                                      state: {
                                        from: location.pathname,
                                      },
                                    },
                                  );
                                }
                              }}
                              className="px-3 py-1 rounded-lg shadow-md border text-black font-medium"
                            >
                              Fill Application
                            </button>
                          ) : (
                            <span className="text-gray-400">—</span>
                          )}
                        </td>
                        <td className="p-2 text-right">
                          <button
                            onClick={() => removeRootShareholder(s.id)}
                            className="text-gray-400 hover:text-red-600"
                          >
                            <img
                              src="/trash.svg"
                              alt="Delete"
                              className="h-4 w-4"
                            />{' '}
                          </button>
                        </td>
                        <td className="p-2">
                          {hasECDDPending(s) ? (
                            <button className="px-4 py-2 rounded-md border border-yellow-600 bg-yellow-50 text-yellow-800 font-medium text-xs uppercase tracking-wide hover:bg-yellow-100 hover:border-yellow-700 transition-all duration-200 shadow-sm">
                              Pending ECDD
                            </button>
                          ) : (
                            <span className="text-gray-400 text-xs">—</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Add Shareholder */}
              <div className="px-4 py-3 flex justify-center ">
                <button
                  onClick={addRootShareholder}
                  className="flex items-center gap-2 text-[#375AE7] rounded-md font-medium text-sm hover:underline border-2 border-dashed p-2"
                >
                  <img
                    src="/add-darkBlue.svg"
                    alt="Add Icon"
                    className="w-5 h-5"
                  />
                  Add Shareholder
                </button>
              </div>
              <div className="flex justify-end px-4 py-4">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleAddShareholders(e);
                  }}
                  disabled={!isFormValid}
                  className={`px-6 py-2 rounded-full text-white ${
                    isFormValid
                      ? 'bg-[#375AE7] hover:bg-gray-900'
                      : 'bg-gray-300 cursor-not-allowed'
                  }`}
                >
                  Save
                </button>
              </div>
            </div>
          )}

          {/* CASE 2: Sub-Layers (with tabs) */}
          {shareholdersForLayer.length > 0 && (
            <div className="">
              {/* Tabs */}
              <div className="flex  border-b">
                {shareholdersForLayer.map((s, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveTab(idx)}
                    className={`px-4 py-2 text-sm font-medium ${
                      activeTab === idx
                        ? 'bg-[#375AE7] text-white'
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                    }`}
                  >
                    {s.parentName}
                  </button>
                ))}
              </div>
              {/* Controls */}
              <Controls
                list={layerData[layerName][activeTab] || []}
                isFirst={false}
                tabIdx={activeTab}
              />
              {/* Tab Content */}

              <div className="p-4 border rounded-b-lg">
                <div className="overflow-x-auto">
                  <table className="w-full text-sm text-gray-700">
                    <thead className="">
                      <tr className="border-[#EDEDED] border font-medium">
                        <th className="p-2 text-left font-medium"></th>
                        <th className="p-2 text-left font-medium">
                          Shareholder Name
                        </th>
                        <th className="p-2 text-left font-medium">
                          Type Of Shareholder
                        </th>
                        <th className="p-2 text-left font-medium">Shares</th>
                        <th className="p-2 text-left font-medium">
                          Email Address
                        </th>
                        <th className="p-2 text-left font-medium">
                          User Registration
                        </th>
                        <th className="p-2"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(layerData[layerName][activeTab] || []).map((s, idx) => (
                        <tr key={s.id} className="border-t font-medium">
                          <td className="p-2 text-[#8C8C8C]">
                            {String(idx + 1).padStart(2, '0')}.
                          </td>
                          <td className="p-2 text-black">
                            <input
                              className="border w-full p-2 rounded-xl text-sm"
                              value={s.name}
                              disabled={true}
                            />
                          </td>
                          <td className="p-2 text-black">
                            <select
                              className="w-full border p-2 rounded-xl text-sm"
                              value={s.type}
                              disabled={true}
                            >
                              {shareholderTypesData.map((c) => (
                                <option key={c.value} value={c.value}>
                                  {c.label}
                                </option>
                              ))}{' '}
                            </select>
                          </td>
                          <td className="p-2 text-black">
                            <div className="relative w-24">
                              <input
                                type="number"
                                value={s.shares}
                                disabled={true}
                                onBlur={(e) => {
                                  let value = parseFloat(e.target.value) || 0;
                                  updateShareholder(
                                    activeTab,
                                    idx,
                                    'shares',
                                    value.toFixed(2),
                                  );
                                }}
                                placeholder="10.00"
                                className={`p-2 pr-8 text-black w-full font-medium border rounded-xl text-md transition-all duration-200 ${'border-gray-300'}`}
                              />
                              <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                                <span className="text-gray-500 text-sm">%</span>
                              </div>
                            </div>
                          </td>
                          <td className="p-2 text-black">
                            <input
                              type="email"
                              className={` ${
                                s.errors?.email ? 'border-[#FF5050]' : ''
                              }
                            border w-full p-2 rounded-xl text-sm`}
                              value={s.email}
                              disabled={true}
                            />
                            {s.errors?.email && (
                              <span className="text-red-500 text-xs">
                                {s.errors.email}
                              </span>
                            )}
                          </td>
                          <td className="p-2">
                            {s.userId != null ? (
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  dispatch(clearStepStatusShareholder());
                                  dispatch(clearCurrentStepShareholder());
                                  if (s.hasPending) {
                                    let redirectState = {
                                      path: `/edd-stakeholder//${s.id}/${s.type}/shareholder/${false}/${s.name}`,
                                      state: {
                                        from: location.pathname,
                                      },
                                    };
                                    sessionStorage.setItem(
                                      'redirectAfterLogin',
                                      JSON.stringify(redirectState),
                                    );
                                    navigate(
                                      `/edd-stakeholder/${s.id}/${s.type}/shareholder/${false}/${s.name}`,
                                      {
                                        state: {
                                          from: location.pathname,
                                        },
                                      },
                                    );
                                  } else {
                                    let redirectState = {
                                      path: `/onboarding-shareholder/${s.id}/${s.type}/shareholder/${false}/${s.name}`,
                                      state: {
                                        from: location.pathname,
                                      },
                                    };
                                    sessionStorage.setItem(
                                      'redirectAfterLogin',
                                      JSON.stringify(redirectState),
                                    );
                                    navigate(
                                      `/onboarding-shareholder/${s.id}/${s.type}/shareholder/${false}/${s.name}`,
                                      {
                                        state: {
                                          from: location.pathname,
                                        },
                                      },
                                    );
                                  }
                                }}
                                className="px-3 py-1 rounded-lg shadow-md border text-black font-medium"
                              >
                                View Application
                              </button>
                            ) : (
                              <span className="text-gray-400">—</span>
                            )}
                          </td>
                          <td className="p-2">
                            {hasECDDPending(s) ? (
                              <button className="px-4 py-2 rounded-md border border-yellow-600 bg-yellow-50 text-yellow-800 font-medium text-xs uppercase tracking-wide hover:bg-yellow-100 hover:border-yellow-700 transition-all duration-200 shadow-sm">
                                Pending ECDD
                              </button>
                            ) : (
                              <span className="text-gray-400 text-xs">—</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const DirectorInfo = ({ setCurrentStep }) => {
  const [loading, setLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [graphData, setGraphData] = useState([]);
  const rejectedFields = useSelector((state) => state.form.rejectedFields);
  const username = useSelector((state) => state.user.username);
  const { shareholderId, shareholderType, userType, shareholderName } =
    useParams();
  const [companyTypeId, setCompanyTypeId] = useState(1);
  const [preselectedSignatory, setPreselectedSignatory] = useState({});
  const stepStatus = useSelector((state) => state.form.stepStatusShareholder);
  const dispatch = useDispatch();
  const [treeData, setTreeData] = useState([]);
  const [showVisualLink, setShowVisualLink] = useState(false);
  const [limitData, setLimitData] = useState([]);
  const [collapsedLayers, setCollapsedLayers] = useState({}); // { layerName: true/false }
  const [minimumInvestment, setminimumInvestment] = useState({
    verification_id: null,
    value: 0,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [companyName, setCompanyName] = useState('Brian	Vaughan');

  const [countries, setCountries] = useState([]);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const addDirectors = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      userType == 'trustee'
        ? `${BASE_URL}/api/v1/onboarding/trust/corporate-trustees/directors-n-shareholders/directors/invitees/${shareholderId}`
        : `${BASE_URL}/api/v1/onboarding/stakeholder/corporate/directors-shareholders/directors/invitees/${shareholderId}`;
    let payload = {
      invitees: members.map((item) => ({
        first_name: item.firstName,
        last_name: item.lastName,
        email: item.email,
        country_code: item.countryCode,
        mobile_number: item.mobile,
        is_managing_member: item.managingMember || false,
      })),
    };

    const bodyData = payload;
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getTypes = async () => {
    try {
      const response = await GetAPIcalls(
        userType == 'trustee'
          ? `/api/v1/onboarding/trust/corporate-trustees/corporate-types/${shareholderId}`
          : `/api/v1/onboarding/stakeholder/corporate/proof-documents/user-company-type/${shareholderId}`,
      );

      if (response.status == 200) {
        setCompanyTypeId(response.data.company_type.id);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  function mapGraphToTree(node) {
    if (!node) return null;

    const relationshipType = node.relationship?.type?.toLowerCase() || 'root';

    const relationshipLabel =
      relationshipType === 'shareholder'
        ? 'Shareholder'
        : relationshipType === 'director'
          ? 'Director'
          : relationshipType === 'trustee'
            ? 'Trustee'
            : relationshipType === 'beneficiary'
              ? 'Beneficiary'
              : relationshipType === 'root'
                ? 'Root entity'
                : relationshipType.charAt(0).toUpperCase() +
                  relationshipType.slice(1);

    return {
      name: node.full_name || 'Unknown',

      type:
        node.entity_type === 'corporate'
          ? 'Corporate'
          : node.entity_type === 'trust'
            ? 'Trust'
            : 'Individual',

      // Display label inside node
      relationship: relationshipLabel,

      // Used for role colours
      relationshipKey: relationshipType,

      ownership: node.relationship?.percentage_ownership,

      meta: {
        relationship: relationshipType,
        ownership: node.relationship?.percentage_ownership,
      },

      children: node.children?.map(mapGraphToTree) || [],
    };
  }
  const getCompanyName = async () => {
    try {
      const response = await GetAPIcalls(
        userType == 'trustee'
          ? `/api/v1/onboarding/trust/corporate-trustees/corporate-information/preview/verification/${shareholderId}`
          : `/api/v1/onboarding/stakeholder/corporate/corporate-information/preview/${shareholderId}/verifications`,
      );

      if (response.status == 200) {
        setCompanyName(response.data.company_full_name.value);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    if (graphData?.graph) {
      const formatted = [mapGraphToTree(graphData.graph)];
      setTreeData(formatted);
    }
  }, [graphData]);
  const getOwnershipgraph = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/customer/ownership-graph/${shareholderId}`,
      );

      if (response.status == 200) {
        setGraphData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const isFirstRecordValid = () => {
    if (!members || members.length === 0) return false;

    const first = members[0];

    return (
      first.firstName?.trim() &&
      first.lastName?.trim() &&
      first.countryCode &&
      first.mobile?.trim() &&
      first.email?.trim() &&
      first.managing !== null &&
      first.beneficialOwner !== null
    );
  };

  const handleCollapseAll = () => {
    const newState = {};
    layers.forEach((l) => (newState[l.name] = true)); // true = collapsed
    setCollapsedLayers(newState);
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleExpandAll = () => {
    const newState = {};
    layers.forEach((l) => (newState[l.name] = false)); // false = expanded
    setCollapsedLayers(newState);
  };
  const [signatoryTypeLabel, setSignatoryTypeLabel] = useState('');
  const [signatoryType, setSignatoryType] = useState(1);
  const [signatoriesData, setSignatoriesData] = useState([]);
  const { showToast } = useToast();
  const [fileAttorney, setFileAttorney] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [actualData, setactualData] = useState([]);
  const [signatoryText, setSignatoryText] = useState('');
  const [signatoryEmail, setSignatoryEmail] = useState('');
  const [signatoryId, setSignatoryId] = useState('');
  const [limitDurationId, setLimitDurationId] = useState(1);
  const [limitDurationLabel, setLimitDurationLabel] = useState('Per Day');
  const [signatoryTypeData, setsignatoryTypeData] = useState([]);
  const [shareholderTypesData, setShareholderTypesData] = useState([]);

  const [preSelectedSignatoryType, setPreSelectedSignatoryType] = useState({
    value: 1,
    label: '1 to Sign',
  });
  const [preSelectedDurationType, setPreSelectedDurationType] = useState({
    value: 1,
    label: 'Per Day',
  });
  const [options, setOptions] = useState([]);
  const [members, setMembers] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const fieldLabelMap = {
    board_resolution_file: 'Board Resolution',
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const buildLayersFromApi = (apiLayers) => {
    return apiLayers.map((layer) => {
      // ROOT
      if (layer.layer_number === 1) {
        return {
          name: 'Interconnection Layer 1',
          layerNumber: 1,
          shareholders: [], // root has NO tabs
          rootEntities: layer.entities || [],
        };
      }

      // SUB LAYERS
      return {
        name: `Interconnection Layer ${layer.layer_number}`,
        layerNumber: layer.layer_number,
        shareholders: layer.tabs.map((t) => ({
          parentId: t.parent_id,
          parentName: t.parent_name,
          data: t.group.shareholders,
        })),
      };
    });
  };
  const getLayeredData = async () => {
    const response = await GetAPIcalls(
      userType == 'trustee'
        ? `/api/v1/onboarding/trust/corporate-trustees/directors-n-shareholders/shareholders/preview/layered/${shareholderId}`
        : `/api/v1/onboarding/stakeholder/corporate/directors-shareholders/shareholders/preview/${shareholderId}/layered`,
    );

    if (response.status === 200) {
      if (response.data.layers.length > 0) {
        const uiLayers = buildLayersFromApi(response.data.layers);
        setLayers(uiLayers);
      }
    }
  };
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null} // handled by react-select
            className="flex-shrink-0 custom-checkbox"
          />
          <span className="truncate">{props.label}</span>
        </div>
      </components.Option>
    );
  };

  // Parent state
  const [layers, setLayers] = useState([
    { name: 'Interconnection Layer 01', shareholders: [] },
  ]);
  const [activeTabIndex, setActiveTabIndex] = useState({});
  const [isFocusedAccountFee, setIsFocusedAccountFee] = useState(false);
  const inputRefAccountFee = useRef(null);
  const optionsdate = [
    { label: 'Never Expire', value: 'never' },
    { label: 'Set Custom Date', value: 'custom' },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [customDate, setCustomDate] = useState('');
  const dropdownRef = useRef();
  const dateInputRef = useRef(null);
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  };
  // parent component
  const addLayer = (qualified, parentName, afterLayerName) => {
    setLayers((prevLayers) => {
      // 1️⃣ Find index of the layer after which new layer should be added
      const idx = prevLayers.findIndex((l) => l.name === afterLayerName);

      // 2️⃣ Keep layers up to current layer
      const baseLayers = idx >= 0 ? prevLayers.slice(0, idx + 1) : [];

      // 3️⃣ Determine new layer number
      const newLayerNumber = baseLayers.length + 1;
      const newLayerName = `Interconnection Layer ${String(
        newLayerNumber,
      ).padStart(2, '0')}`;

      // 4️⃣ Reset shareholder fields for next layer
      const resetShareholders = qualified.map((q) => ({
        id: Date.now() + Math.random(),
        name: q.name, // optional: keep name for tab label
        type: q.type || 1,
        userId: null,
        shares: 0,
        email: '',
        errors: {},
      }));

      const newLayer = {
        name: newLayerName,
        shareholders: resetShareholders,
        parent: parentName,
      };

      return [...baseLayers, newLayer];
    });

    // 5️⃣ Reset active tab indices for trimmed layers and new layer
    setActiveTabIndex((prevTabs) => {
      const newLayerNumber = Object.keys(prevTabs).length + 1;
      const newLayerName = `Interconnection Layer ${String(
        newLayerNumber,
      ).padStart(2, '0')}`;

      return {
        ...prevTabs,
        [afterLayerName]: 0, // reset current layer tab to first
        [newLayerName]: 0, // new layer starts at first tab
      };
    });
  };
  const handleAddDirectors = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addDirectors();
        if (response.status == 200) {
          showToast(response.message, 'success');
          getDirectors();
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [members], // Dependencies
  );
  const formatNumber = (value) => {
    // Remove commas before parsing
    const number = parseFloat(value.toString().replace(/,/g, ''));

    if (isNaN(number)) return '';

    // Format with 2 decimal places and add commas
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const handleSelect = (option) => {
    setSelected(option.value);
    setIsOpen(false);
    setCustomDate('');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getEnums = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/corporate/directors-shareholders/enums`,
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.signatory_types.forEach((profile) => {
          AccountData.push({
            value: profile.value,
            label: profile.label,
          });
        });
        setsignatoryTypeData(AccountData);
        setPreSelectedSignatoryType(AccountData[0]);

        const shareholderTypes = [];
        response.data.shareholder_types.forEach((profile) => {
          shareholderTypes.push({
            value: profile.value,
            label: profile.label,
          });
        });
        setShareholderTypesData(shareholderTypes);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setsignatoryTypeData([]);
          setPreSelectedSignatoryType({});
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setsignatoryTypeData([]);
      setPreSelectedSignatoryType({});
    }
  };

  const getDirectors = async () => {
    try {
      const response = await GetAPIcalls(
        userType == 'trustee'
          ? `/api/v1/onboarding/trust/corporate-trustees/directors-n-shareholders/directors/invitees/${shareholderId}`
          : `/api/v1/onboarding/stakeholder/corporate/directors-shareholders/directors/invitees/${shareholderId}`,
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.directors.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.first_name + ' ' + profile.last_name,
            email: profile.email,
          });
        });
        setOptions(AccountData);
        setSignatoriesData(AccountData);
        setMembers(
          response.data.directors.map((item) => ({
            firstName: item.first_name, // or Date.now() if you want local-only IDs
            lastName: item.last_name,
            countryCode: item.country_code, // 1 = Individual, 2 = Corporate, 3 = Trust
            mobile: item.mobile_number,
            email: item.email,
            managingMember: item.is_managing_member,
          })),
        );
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setsignatoryTypeData([]);
          setPreSelectedSignatoryType({});
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setsignatoryTypeData([]);
      setPreSelectedSignatoryType({});
    }
  };
  const handleChangeAmountFee = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ''); // Remove commas

    if (!isNaN(rawValue) || rawValue === '') {
      const cursorPosition = e.target.selectionStart;

      setminimumInvestment({
        ...minimumInvestment,
        value: rawValue,
      }); // Store raw value without commas
      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefAccountFee.current) {
          inputRefAccountFee.current.setSelectionRange(
            cursorPosition,
            cursorPosition,
          );
        }
      }, 0);
    }
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 text-black" // 👈 black icon
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </components.DropdownIndicator>
    );
  };
  const customStyles = {
    clearIndicator: () => ({ display: 'none' }), // removes the cross
    indicatorSeparator: () => ({ display: 'none' }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: 'white', // hover/focus
      color: 'black',
      cursor: 'pointer',
      ':active': {
        backgroundColor: 'white', // prevent blue flash on click
      },
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: '#d1d5db', // Tailwind gray-300
      boxShadow: 'none', // remove blue focus ring
      '&:hover': { borderColor: '#d1d5db' },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#FCFCFC',
      border: '1px solid #E5E7EB', // Tailwind gray-200
      borderRadius: '10px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#374151', // Tailwind gray-700
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#374151',
      ':hover': { backgroundColor: 'white', color: '' }, // red remove hover
    }),
  };
  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        userType == 'trustee'
          ? `/api/v1/onboarding/trust/corporate-trustees/directors-n-shareholders/preview/verification/${shareholderId}`
          : `/api/v1/onboarding/stakeholder/corporate/directors-shareholders/preview/${shareholderId}/verifications`,
      );

      if (response.status == 200) {
        if (response.data) {
          const signatoryTypeValue = response?.data?.signatory_type?.value;
          if (!signatoryTypeValue) return;

          // ─── Common state ─────────────────────────────────────────────
          setPreSelectedSignatoryType({
            value: signatoryTypeValue.value,
            label: signatoryTypeValue.label,
          });
          setSignatoryType(signatoryTypeValue.id);
          setSignatoryTypeLabel(signatoryTypeValue.name);

          // ─── 1 TO SIGN ────────────────────────────────────────────────
          if (signatoryTypeValue.id === 1) {
            setSignatoryEmail(response?.data?.signatories?.value?.[0] || null);
            let signatory = response.data.directors.filter(
              (item) => item.email === response.data?.signatories?.value?.[0],
            );
            setPreselectedSignatory({
              value: signatory[0].email,
              label: signatory[0].first_name + signatory[0].last_name,
            });
          }

          // ─── Build invitee options once ───────────────────────────────
          const inviteeOptions =
            response.data?.directors?.map((invitee) => ({
              label: `${invitee.first_name} ${invitee.last_name}`,
              value: invitee.id,
              email: invitee.email,
            })) || [];

          const matchedInvitees = inviteeOptions.filter((invitee) =>
            response?.data?.signatories.value.includes(invitee.email),
          );

          // ─── MULTIPLE / ALL TO SIGN ───────────────────────────────────
          switch (signatoryTypeValue.id) {
            case 2: // Selected signatories
              setSelectedOptions(matchedInvitees);
              break;

            case 3: // All invitees
              setSelectedOptions(inviteeOptions);
              break;

            default:
              break;
          }
          setFileAttorney(response.data.board_resolution_file);
        } else {
          setPreSelectedSignatoryType({
            value: 1,
            label: '1 to Sign',
          });
          setSignatoryType(1);
          setSignatoryTypeLabel('');
          setSignatoryEmail('');
          setSelectedOptions([]);
          setFileAttorney({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPreSelectedDurationType({
            value: 1,
            label: 'Per Day',
          });
          setLimitDurationId(1);
          setLimitDurationLabel('Per Day');
          setminimumInvestment({
            verification_id: null,
            value: 0,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setSelected(null);
          setCustomDate('');
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    setMembers((prev) => {
      if (prev.length === 0) return prev;

      return prev.map((member, i) => ({
        ...member,
        managingMember: i === 0 ? true : false, // first one selected by default
      }));
    });
    getEnums();
    getDirectors();
    getTypes();
    getCompanyName();
    getOwnershipgraph();
  }, []); // run only on component mount
  useEffect(() => {
    if (companyTypeId == 1) {
      getLayeredData();
    }
  }, [companyTypeId]); // run only on component mount
  useEffect(() => {
    if (stepStatus.length > 0 && stepStatus[1].status != 'DRAFT') {
      getDetailsWithVerification();
    }
  }, [stepStatus]);
  useEffect(() => {
    setMembers((prev) => {
      // Check if any member is already selected
      const isAnySelected = prev.some((m) => m.managingMember === true);

      if (!isAnySelected && prev.length > 0) {
        // No selection yet → select the first member
        return prev.map((member, i) => ({
          ...member,
          managingMember: i === 0 ? true : false,
        }));
      }

      // Otherwise, keep existing selection
      return prev;
    });
  }, [members.length]); // watch only the length, not full array
  const handleDeleteFile = () => {
    setFileAttorney({
      verification_id: null,
      value: null,
      status: 'pending',
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  };
  const addMember = () => {
    // setisUserPopOpen(true);
    setMembers([
      ...members,
      {
        firstName: '',
        email: '',
        countryCode: '+61',
        mobile: '',
        managingMember: false,
        errors: {
          email: '',
          mobile: '',
        },
      },
    ]);
  };
  const removeMember = (index) => {
    const updated = members.filter((_, i) => i !== index);
    setMembers(updated);
  };
  const updateMember = (index, key, value, newErrors = null) => {
    setMembers((prev) =>
      prev.map((member, i) =>
        i === index
          ? {
              ...member,
              [key]: value,
              errors: newErrors !== null ? newErrors : member.errors,
            }
          : member,
      ),
    );
  };
  const handleSelectSignatory = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setSignatoryId(selectedOption.value);
    setSignatoryText(selectedOption.label);
    setSignatoryEmail(selectedOption.email);
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const formData3 = new FormData();
    formData3.append('file', file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const handleFileChangeAttorney = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileAttorney({
              ...fileAttorney,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileAttorney({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl =
      userType == 'trustee'
        ? `${BASE_URL}/api/v1/onboarding/trust/corporate-trustees/directors-n-shareholders/reset/${shareholderId}`
        : `${BASE_URL}/api/v1/onboarding/stakeholder/corporate/directors-shareholders/reset/${shareholderId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
        getDetailsWithVerification();
        if (userType == 'trustee') {
          const responseStatus = await GetAPIcalls(
            `/api/v1/onboarding/trust/corporate-trustees/sections/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/api/v1/onboarding/trust/corporate-trustees/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          const responseStatus = await GetAPIcalls(
            `/api/v1/onboarding/stakeholder/status/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/api/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleBack = () => {
    setCurrentStep(1);
  };
  const handleContinue = (isFinal) => {
    if (signatoryType === 1 && !signatoryEmail) {
      showToast('Please select a signatory.', 'error');
      return;
    }
    if (signatoryType === 2 && selectedOptions.length === 0) {
      showToast('Please select at least one signatory.', 'error');
      return;
    }
    if (!fileAttorney.value) {
      showToast('Please upload board resolution document.', 'error');
      return;
    }
    setLoading(true);
    handlesave(isFinal);
  };
  const handleSelectSignatoryType = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setSignatoryType(selectedOption.value);
    setSignatoryTypeLabel(selectedOption.label);
    if (selectedOption.value == 3) {
      setSelectedOptions(options);
    }
  };
  const handleSelectDurationType = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setLimitDurationId(selectedOption.value);
    setLimitDurationLabel(selectedOption.label);
  };

  const submitApplicationAPI = async (isFinal) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl =
      userType == 'trustee'
        ? `${BASE_URL}/api/v1/onboarding/trust/corporate-trustees/directors-n-shareholders/submit/${shareholderId}`
        : `${BASE_URL}/api/v1/onboarding/stakeholder/corporate/directors-shareholders/submit/${shareholderId}`;
    console.log('selected ' + selectedOptions.length);
    let signatories =
      signatoryType == 1
        ? [signatoryEmail]
        : signatoryType === 2
          ? selectedOptions.map((item) => item.email)
          : options.map((item) => item.email);
    let bodyData = {
      signatory_type: signatoryType,
      signatories: signatories,
      board_resolution_file: {
        file_id: fileAttorney.value.file_id,
        file_name: fileAttorney.value.file_name,
      },
      is_submitted: isFinal,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI(isFinal);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(3);
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          if (userType == 'trustee') {
            const responseStatus = await GetAPIcalls(
              `/api/v1/onboarding/trust/corporate-trustees/sections/${shareholderId}`,
            );
            if (responseStatus.status == 200) {
              if (responseStatus.data.length > 0) {
                dispatch(setStepStatusShareholder(responseStatus.data));
              }
            }
            const responseRejected = await GetAPIcalls(
              `/api/v1/onboarding/trust/corporate-trustees/rejected-fields/${shareholderId}`,
            );
            if (responseRejected.status == 200) {
              dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
            }
          } else {
            const responseStatus = await GetAPIcalls(
              `/api/v1/onboarding/stakeholder/status/${shareholderId}`,
            );
            if (responseStatus.status == 200) {
              if (responseStatus.data.length > 0) {
                dispatch(setStepStatusShareholder(responseStatus.data));
              }
            }
            const responseRejected = await GetAPIcalls(
              `/api/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
            );
            if (responseRejected.status == 200) {
              dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
            }
          }
        } else {
          toastMessage = {
            message:
              'Information has been saved successfully. Please submit to proceed further.',
            type: 'success',
          };
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible mb-4">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[1].status == 'IN_REVIEW' ||
            stepStatus[1].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}

        {stepStatus.length > 0 && stepStatus[1].status == 'APPROVED' && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.DIRECTORS_SHAREHOLDERS?.rejected_fields?.length >
          0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.DIRECTORS_SHAREHOLDERS.rejected_fields.length ===
              1
                ? 'The following field requires correction:'
                : 'The following fields require correction:'}{' '}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.DIRECTORS_SHAREHOLDERS.rejected_fields.map(
                (field) => (
                  <span
                    key={field}
                    className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                  >
                    {fieldLabelMap[field] || field.replace(/_/g, ' ')}
                  </span>
                ),
              )}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          {/* Header */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between border-b border-colour-custom px-4 pb-2 mb-4 gap-2">
            <div className="flex items-center gap-2">
              <img src="/people.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Directors:{' '}
                <span className="text-[#8C8C8C] font-medium">
                  {companyName}
                </span>
              </h1>
            </div>
            <div className="flex flex-col sm:flex-row gap-1 sm:gap-2 items-start sm:items-center">
              <span className="text-sm text-labelColour">
                Number of directors within your organisation:
              </span>
              <span className="text-sm font-medium text-black">
                <div className="font-semibold">
                  <div className="flex items-center text-sm mt-1 md:mt-0 space-x-0 ml-1 border  rounded-md bg-white shadow-md">
                    {/* Remove last row */}
                    <button
                      onClick={() => {
                        setMembers((prev) => {
                          if (prev.length === 0) return prev; // avoid error if no rows
                          return prev.slice(0, prev.length - 1); // remove last member
                        });
                      }}
                      className="text-black px-2"
                    >
                      <Minus size={18} />
                    </button>

                    {/* Count display */}
                    <span className="text-sm font-medium bg-[#375AE7] text-white p-2">
                      {members.length.toString().padStart(2, '0')}
                    </span>

                    {/* Add new row */}
                    <button onClick={addMember} className="text-black px-2">
                      <Plus size={18} />
                    </button>
                  </div>
                </div>
              </span>
            </div>
          </div>

          {/* Info Alert */}
          <div className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
            Information of all the Directors must be added. Please ensure before
            submitting the form. Failing to do so will lead in resubmitting the
            application.
          </div>

          {/* Directors Table */}
          <div className="overflow-x-auto">
            <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
              <thead className="bg-[#F9F9F9] text-labelColour font-semibold">
                <tr>
                  <th className="p-2 w-[40px]"></th>
                  <th className="p-2">First Name</th>
                  <th className="p-2">Last Name</th>
                  <th className="p-2">Email Address</th>
                  <th className="p-2">Mobile Number</th>
                  <th className="p-2">Managing Member</th>
                  <th className="p-2 w-[40px]"></th>
                </tr>
              </thead>
              <tbody>
                {members.map((member, idx) => (
                  <tr key={idx} className="border-t bg-white align-top">
                    <td className="p-2 font-medium text-labelColour">
                      {(idx + 1).toString().padStart(2, '0')}.
                    </td>
                    <td className="p-2">
                      <input
                        className="border w-full p-2 rounded-xl text-sm"
                        placeholder="First Name"
                        value={member.firstName}
                        onChange={(e) =>
                          updateMember(idx, 'firstName', e.target.value)
                        }
                      />
                    </td>
                    <td className="p-2">
                      <input
                        className="border w-full p-2 rounded-xl text-sm"
                        placeholder="Last Name"
                        value={member.lastName}
                        onChange={(e) =>
                          updateMember(idx, 'lastName', e.target.value)
                        }
                      />
                    </td>
                    <td className="p-2">
                      <div className="flex flex-col">
                        <input
                          className={`border w-full p-2 rounded-xl text-sm ${
                            member.errors?.email ? 'border-red-500' : ''
                          }`}
                          type="email"
                          placeholder="Email"
                          value={member.email}
                          onChange={(e) => {
                            const value = e.target.value;
                            const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                              value,
                            );
                            updateMember(idx, 'email', value, {
                              ...member.errors,
                              email:
                                isValid || value === ''
                                  ? ''
                                  : 'Invalid email address',
                            });
                          }}
                        />
                        {member.errors?.email && (
                          <span className="text-red-500 text-xs mt-1">
                            {member.errors.email}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="p-2">
                      <div className="flex flex-col">
                        <div
                          className={`flex items-center border rounded-xl overflow-hidden ${
                            member.errors?.mobile ? 'border-red-500' : ''
                          }`}
                        >
                          <select
                            className="px-2 text-sm text-[#888888] font-medium bg-transparent outline-none"
                            value={member.countryCode}
                            onChange={(e) => {
                              const isValid = validator.isMobilePhone(
                                e.target.value + member.mobile,
                                'any',
                              );
                              updateMember(idx, 'countryCode', e.target.value, {
                                ...member.errors,
                                mobile:
                                  isValid || e.target.value === ''
                                    ? ''
                                    : 'Enter a valid mobile number',
                              });
                            }}
                          >
                            {countries.map((c) => (
                              <option key={c.code} value={c.dialCode}>
                                {c.code} ({c.dialCode})
                              </option>
                            ))}
                          </select>
                          <input
                            className={`outline-none p-2 text-sm w-full ${
                              member.errors?.mobile ? 'border-red-500' : ''
                            }`}
                            placeholder="Mobile"
                            value={member.mobile}
                            onChange={(e) => {
                              const value = e.target.value;
                              const isValid = validator.isMobilePhone(
                                member.countryCode + value,
                                'any',
                              );
                              updateMember(idx, 'mobile', value, {
                                ...member.errors,
                                mobile:
                                  isValid || value === ''
                                    ? ''
                                    : 'Enter a valid mobile number',
                              });
                            }}
                          />
                        </div>
                        {member.errors?.mobile && (
                          <span className="text-red-500 text-xs mt-1">
                            {member.errors.mobile}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="p-2 flex justify-center items-center">
                      <input
                        type="radio"
                        name="managingMember"
                        value={true}
                        checked={member.managingMember == true}
                        onChange={(e) => {
                          const value = e.target.value === 'true';
                          updateMember(idx, 'managingMember', value);
                        }}
                        className="w-6 h-4 confirm-check border-gray-300 focus:ring-[#375AE7]"
                      />
                    </td>
                    {idx !== 0 && (
                      <td className="p-2 text-center">
                        <button
                          onClick={() => removeMember(idx)}
                          title="Remove"
                          className="text-red-500"
                        >
                          <img
                            src="/trash.svg"
                            alt="Delete"
                            className="h-4 w-4"
                          />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Add Director Button */}
          <div className="px-4 py-3 flex justify-center">
            <button
              onClick={addMember}
              className="flex items-center gap-2 text-[#375AE7] rounded-md font-medium text-sm hover:underline border-2 border-dashed p-2"
            >
              <img src="/add-darkBlue.svg" alt="Add Icon" className="w-5 h-5" />
              Add Director
            </button>
          </div>

          {/* Save Button */}
          <div className="flex justify-end w-full mt-4">
            <button
              onClick={(e) => {
                e.preventDefault();
                setLoading(true);
                handleAddDirectors(e);
              }}
              className={`${
                members.length == 0 ||
                members.some(
                  (member) =>
                    member.errors &&
                    Object.values(member.errors).some(
                      (error) => error && error !== '',
                    ),
                ) ||
                (members.length > 0 && members[0].email === '')
                  ? 'bg-gray-300  cursor-not-allowed'
                  : 'bg-[#375AE7] hover:bg-gray-900'
              } w-full md:w-auto  text-white font-medium py-2 px-4 rounded-full text-sm`}
            >
              Save
            </button>
          </div>

          {/* Signatory Section */}
          {members.length > 0 &&
            (signatoriesData.length > 0 || options.length > 0) && (
              <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Signatory Type */}
                <div className="flex flex-col px-2 pt-4">
                  <Dropdown
                    label={
                      <>
                        Select Signatory Type
                        <span className="text-red-500">*</span>
                      </>
                    }
                    options={signatoryTypeData}
                    onSelect={handleSelectSignatoryType}
                    preselectedValue={preSelectedSignatoryType}
                  />
                </div>

                {/* Signatories */}
                <div className="flex flex-col px-2 pt-4 border-t md:border-t-0 md:border-l border-gray-300">
                  {signatoryType === 1 && (
                    <Dropdown
                      label={
                        <>
                          Select Signatory
                          <span className="text-red-500">*</span>
                        </>
                      }
                      options={signatoriesData}
                      onSelect={handleSelectSignatory}
                      preselectedValue={preselectedSignatory}
                    />
                  )}
                  {signatoryType === 2 && (
                    <div className="">
                      <label className="block mb-2 text-sm text-gray-700">
                        Select Signatories{' '}
                        <span className="text-red-500">*</span>
                      </label>
                      <Select
                        options={options}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{ Option, DropdownIndicator }}
                        onChange={setSelectedOptions}
                        allowSelectAll={true}
                        value={selectedOptions}
                        className="text-sm rounded-md w-full"
                        placeholder=""
                        styles={customStyles}
                      />
                      {selectedOptions.length === 0 && (
                        <label className="block mt-1 text-xs text-[#FF5050] flex items-center">
                          <img
                            src="/danger.svg"
                            alt="alert Icon"
                            className="h-4 w-4 mr-1"
                          />
                          Please select at least one signatory.
                        </label>
                      )}
                    </div>
                  )}

                  {signatoryType === 3 && (
                    <div className="mt-2">
                      <label className="block mb-2 text-sm text-gray-700">
                        Select Signatories{' '}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="mt-1 border rounded-md border-gray-300 p-2 flex flex-wrap gap-2">
                        {options.map((opt, index) => (
                          <div
                            key={index}
                            className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                          >
                            <span>{opt.label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* File Upload */}
                <div className="flex flex-col px-2 pt-4">
                  <LabelWithStatus
                    id="contracttype"
                    label={fieldLabelMap.board_resolution_file}
                    required={true}
                    fieldData={fileAttorney}
                    handleStatusClick={handleStatusClick}
                  />
                  <label className="border-2 border-dashed rounded-lg p-6 block text-center cursor-pointer flex flex-col items-center">
                    <input
                      type="file"
                      id="fileUpload"
                      accept=".pdf,.png,.jpeg"
                      onChange={handleFileChangeAttorney}
                      disabled={fileAttorney.status == 'approved'}
                      className="hidden"
                    />
                    <img
                      src="/folder-add.svg"
                      alt="Upload Icon"
                      className="h-4 w-4"
                    />
                    <p className="mt-2 text-gray-500 text-sm">
                      Drag & Drop <br /> or{' '}
                      <span className="underline">Click to Upload</span>
                    </p>
                  </label>
                  <div className="mt-2 flex gap-2 flex-wrap text-xs">
                    {['PNG', 'JPEG', 'PDF', '< 10 MB'].map((item, idx) => (
                      <span
                        key={idx}
                        className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md"
                      >
                        {item}
                      </span>
                    ))}
                  </div>

                  {fileAttorney && fileAttorney.value && (
                    <div
                      className={`${
                        fileAttorney.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : 'border'
                      }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                    >
                      {' '}
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(e, fileAttorney.value);
                        }}
                        className="flex flex-col"
                      >
                        <span className="text-black underline cursor-pointer">
                          {fileAttorney.value.file_name}
                        </span>
                        <span className="text-[#46DA55] text-xs">
                          Upload Completed
                        </span>
                      </div>
                      <button
                        onClick={handleDeleteFile}
                        className="text-red-500 flex-shrink-0 font-semibold"
                      >
                        <img
                          src="/trash.svg"
                          alt="Delete"
                          className="h-4 w-4"
                        />
                      </button>
                    </div>
                  )}
                  <div className="flex justify-end w-full mt-4">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        handleContinue(false);
                      }}
                      className={`bg-[#375AE7] w-full md:w-auto  text-white font-medium py-2 px-4 rounded-full text-sm`}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
          {isUserPopOpen && (
            <AddUserPopup
              setactualData={setactualData}
              onClose={() => setisUserPopOpen(false)}
            />
          )}
        </div>
        {companyTypeId == 1 && (
          <div className="bg-white shadow-md rounded-md p-4 mt-4">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-2 md:space-y-0 px-4">
              <div className="flex items-center space-x-2">
                <img src="/people.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">
                  Shareholders:
                  <span className="text-xl font-medium text-[#8C8C8C] ml-1">
                    {companyName}
                  </span>
                </h1>
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={() => {
                    setShowVisualLink(true);
                  }}
                  className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                >
                  <img
                    src="/hashtag.svg"
                    alt="Collapse Icon"
                    className="w-4 h-4 flex-shrink-0"
                  />
                  <span className="font-medium">Visual Link</span>
                </button>
                <button
                  onClick={handleCollapseAll}
                  className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                >
                  <img
                    src="/arrow-square-up.svg"
                    alt="Collapse Icon"
                    className="w-4 h-4 flex-shrink-0"
                  />
                  <span className="font-medium">Collapse All</span>
                </button>
                <button
                  onClick={handleExpandAll}
                  className="bg-[#375AE7] text-white text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                >
                  <img
                    src="/arrow-square-down.svg"
                    alt="Collapse Icon"
                    className="w-4 h-4 flex-shrink-0"
                  />
                  <span className="font-medium">Expand All</span>
                </button>
              </div>
            </div>
            {showVisualLink && (
              <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[99999]">
                <div className="relative bg-white rounded-2xl shadow-2xl w-[95%] md:w-[900px] p-6">
                  {/* Close Button */}
                  <button
                    onClick={() => setShowVisualLink(false)}
                    className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl font-bold transition-colors"
                  >
                    &times;
                  </button>

                  {/* Graph */}
                  <div className="mt-6 w-full h-[500px] border border-gray-200 rounded-xl overflow-hidden">
                    <MindmapTree data={treeData} />{' '}
                  </div>
                </div>
              </div>
            )}

            <ul className="space-y-2 pl-6 pr-2 text-xs font-medium text-black list-disc">
              <li>Please provide shareholder details for your company here.</li>
              <li>
                If a corporate entity or trust holds 25% or more shares, we'll
                create interconnection layers to identify the shareholders of
                those entities. This will continue until we identify the
                individual ultimate beneficial owner of your company.
              </li>
              <li>
                Please complete the application for any corporate or trust
                shareholder who owns 25% or more shares. Failure to do so will
                prevent you from continuing the application.
              </li>
              <li>
                The application for the individual ultimate beneficial owners
                will be sent to the email address you provide here, To obtain
                the additional information Ratified requires.
              </li>
            </ul>
            <div className="p-6">
              {layers.map((layer) => (
                <ShareholderLayer
                  key={layer.layerNumber}
                  layerName={layer.name}
                  shareholdersForLayer={layer.shareholders}
                  rootEntities={layer.rootEntities}
                  shareholderTypesData={shareholderTypesData}
                  collapsed={collapsedLayers[layer.name] ?? false}
                  getLayeredData={getLayeredData}
                  onToggle={() =>
                    setCollapsedLayers((p) => ({
                      ...p,
                      [layer.name]: !p[layer.name],
                    }))
                  }
                />
              ))}
            </div>
          </div>
        )}
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      <footer className=" mt-4 flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7] z-50">
        {stepStatus.length > 0 &&
          stepStatus[1].status != 'COMPLETED' &&
          stepStatus[1].status != 'APPROVED' &&
          stepStatus[1].status != 'IN_REVIEW' && (
            <>
              <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={true}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>
              <div className="bottom-actions flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
                <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                  {/* Save as Draft */}
                  <button
                    onClick={() => {
                      handleContinue(false);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Save as Draft</span>
                  </button>

                  <ConfirmContinueButton
                    onContinue={() => handleContinue(true)}
                    buttonText="Continue"
                    confirmTitle="Save Section"
                    confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                  />
                </div>
              </div>
            </>
          )}
        {stepStatus.length > 0 &&
          (stepStatus[1].status == 'COMPLETED' ||
            stepStatus[1].status == 'APPROVED' ||
            stepStatus[1].status == 'IN_REVIEW') && (
            <>
              <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={false}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>
              <div className="bottom-actions flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
                <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                  {/* Save as Draft */}
                  <button
                    onClick={() => {
                      setCurrentStep(3);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Next</span>
                  </button>
                </div>
              </div>
            </>
          )}
      </footer>
    </div>
  );
};

export default DirectorInfo;
